/**
 * Generates a pseudo-random string of specified length
 * @param {Number} count string length
 * @returns {String}
 */
export const getRandomString = (count = 32) => [...Array(count)].map(() => (~~(Math.random() * 32)).toString(32)).join('');
